import { LifeExpectancyInformationType } from 'sigma-mappings';

/* istanbul ignore next */
const lifeExpectancyFields = {
  inYears: {
    isRequired: informationType => informationType === LifeExpectancyInformationType.IN_YEARS,
    getMaxLength: max => (max || '').toString().length,
    precision: 0,
    minValue: 1,
    getMaxValue: max => max,
  },
  inPercentage: {
    isRequired: informationType => informationType === LifeExpectancyInformationType.IN_PERCENTAGE,
    getMaxLength: () => 5,
    precision: 1,
    minValue: 0,
    getMaxValue: () => 100,
  },
};

export default lifeExpectancyFields;
